export const KEYCODES = {
  P: 80,
  H: 72,
  S: 83,
  Q: 81,
  K: 75,
}
